(() => {
  const search = document.querySelector('.header__search'),
        searchButton = document.querySelectorAll('.site-nav__searchLink'),
        searchClose = document.querySelector('.header__searchClose'),
        pageContainer = document.querySelector('.page-container'),
        mainContent = document.querySelector('.main-content');

  function showSearch() {
    search.classList.add('header__search--active');
    pageContainer.classList.add('pageContainer--opacity');
    mainContent.classList.add('main-content--opacity');
  }

  function closeSearch() {
    search.classList.remove('header__search--active');
    pageContainer.classList.remove('pageContainer--opacity');
    mainContent.classList.remove('main-content--opacity');
  }

  searchClose.addEventListener('click', closeSearch);

  searchButton.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      showSearch();
    });
  });
})();